import _ from 'lodash';
import { connect } from 'react-redux';
import { search, add } from '../../modules/billing/quickbooksFreightAccount';
import { showErrors } from '../../modules/general';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state) => {
	/** @namespace state.lists.quickbooksFreightAccountIds **/
	/** @namespace state.maps.quickbooksFreightAccount **/
	let quickbooksFreightAccounts = undefined;
	if (state.lists.quickbooksFreightAccountIds) {
		quickbooksFreightAccounts = _.map(
			state.lists.quickbooksFreightAccountIds,
			id => state.maps.quickbooksFreightAccount[id]
		);
	}
	return {
		quickbooksFreightAccounts,
		quickbooksAccountMap : state.maps.quickbooksAccount,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	addQuickbooksFreightAccount : add,
	searchQuickbooksFreightAccounts : search,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
